//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtArrowLink from '~/components/other/MtArrowLink';
import { getArrForTitle, getContentByCode } from '~/utils/utils';
export default {
  components: {
    MtArrowLink
  },
  methods: {
    getTextArr(text) {
      return getArrForTitle(text)
    },
    getTable(text) {
      const arr = getArrForTitle(text)
      return arr.map((elem) => elem.split('<re>'))
    },
    getContent(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    },
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'terms-price-texts',
        auto: true,
        params: {
          code: [
            'rastsenki-tablitsa'
          ],
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
}
